import {FC, useCallback, useEffect, useState} from "react";
import {DescriptionWrapper, FilterContainer, ImageWrapper} from "./styles";
import {IFiltersTop} from "./types";
import {arrayFromNumber} from "../../helper/functions";
import {Tooltip} from "react-tooltip";
import {
  IFintechFilters,
  IFintechWeakSignalsFilters,
} from "../../pages/Fintech/FintechDashboard.type";
import {IdashboardFilters} from "../../pages/Dashboard/Dashboard.type";
import {IEsgFilters} from "../../pages/Esg/EsgDashboard.type";
import {IStateInitiativeFilters} from "../../pages/StateInitiative/StateInitiative.type";
import {ITypeRadar} from "../../types";

interface IProps {
  item: IFiltersTop;
  typeRadar: ITypeRadar;
  filters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  typedFilters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  filterWeakSignals?: IFintechWeakSignalsFilters;
  onFilterChange: <T>(filter: string, value?: T) => void;
  isResetFilters?: boolean;
  setIsResetFilters?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FilterItemSeveral: FC<IProps> = ({
  item,
  typeRadar,
  filters,
  typedFilters,
  filterWeakSignals,
  onFilterChange,
  isResetFilters,
  setIsResetFilters,
}) => {
  const [countActiveFilter, setCountActiveFilter] = useState(
    (typedFilters as Record<string, any>)[item.id]?.value || 0
  );

  const handleVolumeClick = useCallback(
    (filter: string) => {
      setCountActiveFilter((prev: number) => {
        if (prev === 3) {
          return 0;
        } else {
          return prev + 1;
        }
      });
      if (setIsResetFilters) setIsResetFilters(false);
    },
    [setCountActiveFilter]
  );

  useEffect(() => {
    if (isResetFilters) {
      setCountActiveFilter(0);
    }
  }, [isResetFilters]);

  useEffect(() => {
    onFilterChange(
      item.id,
      (filters as {[key: string]: any})[item.id] === countActiveFilter
        ? item.id === "priority_level"
          ? ""
          : 0
        : countActiveFilter
    );
  }, [countActiveFilter]);

  return (
    <FilterContainer
      id={item.id}
      data-tooltip-id={item.id}
      data-tooltip-content={item.tooltip}
      onClick={() =>
        filterWeakSignals?.weak_signal ? null : handleVolumeClick(item.id)
      }
      isactive={(countActiveFilter !== 0 ? true : false).toString()}
      disabled={filterWeakSignals?.weak_signal ? true : false}
    >
      {arrayFromNumber(item.countItems).map((index) => {
        // count++;
        return (
          <ImageWrapper
            key={`${item.id}-${index}`}
            disabled={filterWeakSignals?.weak_signal ? true : false}
          >
            <img
              src={item.icon}
              width={"100%"}
              height={"100%"}
              style={
                Number(
                  countActiveFilter
                  // (filters as keyof typeof typedFilters)?.[
                  //   item.id as keyof typeof typedFilters
                  // ]
                ) <= index
                  ? {opacity: 0.4}
                  : {opacity: 1}
              }
              alt={"alt"}
            />
          </ImageWrapper>
        );
      })}
      {filterWeakSignals?.weak_signal ? null : (
        <Tooltip
          id={item.id}
          className="tooltip"
          place={"bottom-start"}
          style={{userSelect: "none"}}
          noArrow
        />
      )}
      <DescriptionWrapper
        isactive={(countActiveFilter !== 0 ? true : false).toString()}
      >
        <span>{item.tooltip}</span>
      </DescriptionWrapper>
    </FilterContainer>
  );
};
